import BpkButton from '@skyscanner/backpack-web/bpk-component-button';
import BpkText, {
  TEXT_STYLES,
} from '@skyscanner/backpack-web/bpk-component-text/src/BpkText';
import { cssModules } from '@skyscanner/backpack-web/bpk-react-utils';

import { withI18n } from '../../../../services/i18n';

import type { I18nShape } from '../../../../services/i18n';
import type { Maybe } from '../../../../types';

import STYLES from './ApplyFooter.scss';

type Props = {
  checkOut?: Maybe<Date>;
  showCalculatedPrice: boolean;
  disabled?: boolean;
  averagePrice?: number;
  nightCount?: number;
  minPrice?: number;
  i18n: I18nShape;
  onApply: Function;
};

const cls = cssModules(STYLES);

const ApplyFooter = ({
  averagePrice = undefined,
  checkOut = undefined,
  disabled = false,
  i18n: { formatCurrency, translate, translatePlural },
  minPrice = undefined,
  nightCount = 0,
  onApply,
  showCalculatedPrice,
}: Props) => (
  <div className={cls('ApplyFooter')}>
    {checkOut && (
      <div className={cls('ApplyFooter__applyContent')}>
        {showCalculatedPrice && averagePrice ? (
          <BpkText tagName="p" textStyle={TEXT_STYLES.bodyDefault}>
            {translate('DateRangeSelector_applyLabel_pricePerNight', {
              cost: formatCurrency(averagePrice),
            })}
          </BpkText>
        ) : (
          ''
        )}
        <div className={cls('ApplyFooter__applyNight')}>
          <BpkText tagName="p" textStyle={TEXT_STYLES.bodyDefault}>
            {nightCount &&
              translatePlural(
                'SelectionSummary_label_nights',
                nightCount,
                'number',
              )}
            &nbsp;
            <span>
              {showCalculatedPrice && minPrice
                ? translate('DateRangeSelector_applyLable_FromPrice', {
                    0: formatCurrency(minPrice),
                  })
                : ''}
            </span>
          </BpkText>
        </div>
      </div>
    )}
    {!checkOut && (
      <div className={cls('ApplyFooter__selectLabel')}>
        <BpkText tagName="p" textStyle={TEXT_STYLES.bodyDefault}>
          {translate('label_calendar_select_checkIn_date_footer')}
        </BpkText>
      </div>
    )}
    <div>
      <BpkButton
        id="applyFooter__apply"
        onClick={onApply}
        className={cls('ApplyFooter__applyButton')}
        disabled={disabled}
      >
        {translate('HotelStay_label_Done')}
      </BpkButton>
    </div>
  </div>
);

export default withI18n(ApplyFooter);
